import { HorizontalButtonPairView } from '../components/DRViewUtils';
import CornerGripperLogo from '../components/CornerGripperLogo';
import './ErrorScreen.scss';

export interface ErrorScreenProps {
  buttonAction?: () => void;
  buttonText?: string;
  subtitle?: string;
  tapToReload: () => void;
  title: string;
}

export default function ErrorScreen({ buttonText, buttonAction, subtitle, tapToReload, title }: ErrorScreenProps) {
  const buttonSettings = [
    {
      phrase: buttonText,
      fillColor: 'transparent',
      borderColor: '#03A4B5',
      fontColor: '#03A4B5',
      action: buttonAction,
    },
  ];

  return (
    <div className="error-screen">
      <CornerGripperLogo tapToReload={tapToReload} />
      <div className="error-screen__content">
        <img alt="Moxi help" draggable="false" src={require('../assets/images/moxi-question.png')} />
        <h1 className="error-screen__title">{title}</h1>
        {subtitle && <h4 className="error-screen__subtitle">{subtitle}</h4>}
      </div>
      <div className="error-screen__footer">
        {buttonText && buttonAction && <HorizontalButtonPairView buttonSettings={buttonSettings} />}
      </div>
    </div>
  );
}
